export const formatPercentage = (percentage: number, figures: number = 2) => {
  const numerals = Math.min(Math.max(figures, 2), 5)
  const percent = percentage * 100
  const integerDigits = percent >= 100 ? 3 : percent >= 10 ? 2 : percent >= 1 ? 1 : 0
  const decimals = Math.max(numerals - integerDigits, 0)

  return percent.toFixed(decimals)
}
